<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :loading="loading"
    :items="studentExams"
    :items-per-page="10"
    :mobile-breakpoint="900"
    :footer-props="{ 'items-per-page-text': 'Số kỳ kiểm tra mỗi trang' }"
    v-bind="this.$attrs"
  >
    <template v-slot:[`footer.page-text`]="items">
      Kỳ kiểm tra thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} kỳ kiểm tra
    </template>
    <template v-slot:[`item.subjects`]="{ item }">
      <div style="height: 100%; ">
        <StudentSubjectCard :item="item" />
      </div>
    </template>
    <template v-slot:[`item.student`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        <StudentExamCard :student="item.student" />
      </div>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item.exam.name }}
      </div>
    </template>
    <template v-slot:[`item.examCode`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item.examCode }}
      </div>
    </template>
    <template v-slot:[`item.reviewDate`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item.exam.reviewDate | getDate }}
      </div>
    </template>
    <template v-slot:[`item.exam`]="{ item }">
      <div style="height: 100%; padding-top: 10px;">
        <a
          v-if="item.exam && item.exam.files && item.exam.files.length > 0"
          :href="`${item.exam.files[0].url}`"
          target="_blank"
          >Xem chi tiết</a
        >
        <span v-else>Chưa có</span>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { get } from 'lodash'
import moment from 'moment'
import StudentSubjectCard from './StudentSubjectCard.vue'
import StudentExamCard from '../../../components/basic/card/StudentExamCard.vue'
const originHeaders = [
  {
    text: 'Kỳ kiểm tra',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Học sinh',
    value: 'student',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Số báo danh',
    value: 'examCode',
    align: 'left',
    sortable: false,
    show: true,
    width: '12%'
  },
  {
    text: 'Môn - Thời gian - Địa điểm',
    value: 'subjects',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Hạn phúc khảo',
    value: 'reviewDate',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Lịch kiểm tra',
    value: 'exam',
    align: 'left',
    sortable: false,
    show: true,
    width: '10%'
  }
]

export default {
  props: {
    exams: Array,
    studentExams: Array
  },
  components: {
    StudentSubjectCard,
    StudentExamCard
  },
  data() {
    return {
      loading: false,
      headers: originHeaders
    }
  },
  created() {},
  watch: {},
  filters: {
    getDesc: item => {
      return get(item, 'note', 'Chưa có thông tin')
    },
    getStatus: item => {
      if (item.status === 'active') {
        return 'Đang hoạt động'
      } else if (item.status === 'inActive') {
        return 'Đã bị khóa'
      } else if (item.status === 'removed') {
        return 'Đã bị xóa'
      } else {
        return ''
      }
    },
    getDate: item => {
      if (item) return moment(item).format('DD/MM/YYYY')
      return 'Chưa có thông tin'
    }
  }
}
</script>
